module.exports = __webpack_public_path__ + "img/Lumina_island_raw.cc194363.png";